module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp123_1.e1ec22bc.png";